/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, { useState } from 'react';
import {
    node,
} from 'prop-types';

import ContextModal from './modal-context';

const ModalContextProvider = ({ children }) => {
    const [calendarModalIsOpen, setCalendarModalOpen] = useState(false);
    const [addonOrderItemId, setAddonOrderItemId] = useState(null);
    const [itemCountriesProdDeliverable, setItemCountriesProdDeliverable] = useState([]);
    const [itemDetailData, setItemDetailData] = useState({});
    const [itemRecipientData, setItemRecipientData] = useState({});
    const [wrapperModalIsOpen, setWrapperModalOpen] = useState(false);
    const [personalizationIsOpen, setPersonalizationOpen] = useState(false);
    const [refnum, setRefnum] = useState(false);
    const [pmallIsOpen, setPmallOpen] = useState(false);
    const [addressBookIsOpen, setAddressBookIsOpen] = useState(false);
    const [orderItemIdQASModal, setOrderItemIdQASModal] = useState('');
    const [parentType, setParentType] = useState('recipient'); // type: recipient - addressbook
    const [recipientGreetingData, setRecipientGreetingData] = useState('recipient'); // type: recipient - addressbook
    const [recipientRedirectTo, setRecipientRedirectTo] = useState('recipient'); // type: recipient - addressbook
    const [buttonTypeQAS, setButtonTypeQAS] = useState(''); // type: recipient - addressbook
    const [contextUserState, setContextUserState] = useState('');

    return (
        <ContextModal.Provider value={
            {
                calendarModalIsOpen,
                setCalendarModalOpen,
                itemDetailData,
                setItemDetailData,
                itemRecipientData,
                setItemRecipientData,
                wrapperModalIsOpen,
                setWrapperModalOpen,
                addonOrderItemId,
                setAddonOrderItemId,
                personalizationIsOpen,
                setPersonalizationOpen,
                refnum,
                setRefnum,
                pmallIsOpen,
                setPmallOpen,
                addressBookIsOpen,
                setAddressBookIsOpen,
                itemCountriesProdDeliverable,
                setItemCountriesProdDeliverable,
                orderItemIdQASModal,
                setOrderItemIdQASModal,
                parentType,
                setParentType,
                recipientGreetingData,
                setRecipientGreetingData,
                recipientRedirectTo,
                setRecipientRedirectTo,
                buttonTypeQAS,
                setButtonTypeQAS,
                contextUserState,
                setContextUserState,
            }
        }
        >
            {children}
        </ContextModal.Provider>
    );
};

ModalContextProvider.propTypes = {
    children: node.isRequired,
};

export default ModalContextProvider;
